import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { JwtService } from './jwt.service';
import { LocalStorageService } from './local-storage.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HttpInterceptorService implements HttpInterceptor {
  private sessionExpired: boolean = false;  // Track session expiry state

  constructor(private jwtService: JwtService,
    public localStorageService: LocalStorageService,
    public toastrService: ToastrService,
    public router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.localStorageService.show();

    // Session is carried via an HttpOnly cookie set by the backend — attach it on every request.
    const clonedReq = req.clone({ withCredentials: true });

    return next.handle(clonedReq).pipe(
      tap((res: any) => {
        if (res.body && res.body.status && res.body.status === 401) {
          this.handleSessionExpiry();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.handleSessionExpiry();
          return of(null);
        }
        return throwError(() => error);
      }),
      finalize(() => this.localStorageService.hide()) // Hide the loading spinner after request completes
    );

  }
  private handleSessionExpiry(): void {

    this.jwtService.destroyToken();  // Clear JWT token
    // this.toastrService.error('Your session has expired. Please log in again.', '', {
    //   progressBar: true,
    //   progressAnimation: 'increasing'
    // });
    this.router.navigate(['/login']);

  }
  resetSessionExpiry(): void {
    this.sessionExpired = false;  // Reset the session expiry flag after successful login
  }
}
